import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { api_routes } from '@app/consts';
import { EnvironmentService } from '@app/core/services/environment.service';
import { PagedData } from '@app/modules/lookup/models/paged-data.model';
import { BackgroundCheck, BackgroundCheckSubmit } from '../models/employee-background-checks.model';
import { Observable } from 'rxjs';

const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class EmployeeBackgroundChecksService {

  constructor(private http: HttpClient, private envService: EnvironmentService) { }

  getBackgroundChecks(employeeId: string, take?: number, skip?: number, sort?: string, filter?: string, asOf?: string): Observable<PagedData<BackgroundCheck>> {
    let params = new HttpParams();
    sort ? params = params.append('sort', sort) : null;
    filter ? params = params.append('filter', filter) : null;
    asOf ? params = params.append('asOf', asOf) : null;
    skip ? params = params.append('skip', skip) : null;
    take ? params = params.append('take', take) : null;

    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.BACKGROUND_CHECKS}`, {
      headers: headers,
      params: params
    });
  }

  async getAllBackgroundChecks(employeeId: string, sort?: string, filter?: string): Promise<PagedData<BackgroundCheck>> {
    let take = 100;
    let skip = 0;
    let allData = {
      skip: null,
      take: null,
      totalPages: null,
      total: null,
      data: []
    }

    while (allData.total === null || skip < allData.total) {
      const res = await this.getBackgroundChecks(employeeId, take, skip, sort, filter).toPromise();

      if (res && res.data && res.data.length > 0) {
        allData.data = allData.data.concat(res.data);
        skip += take;
        allData.total = res.total;
      } else {
        break;
      }
    }

    return allData;
  }

  getBackgroundCheck(employeeId: string, backgroundCheckId: string): Observable<BackgroundCheck> {
    let params = new HttpParams();

    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.BACKGROUND_CHECKS}/${backgroundCheckId}`, {
      headers: headers,
      params: params
    });
  }

  createBackgroundCheck(employeeId: string, backgroundCheckSubmit: BackgroundCheckSubmit): Observable<any> {
    return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.BACKGROUND_CHECKS}`, backgroundCheckSubmit, {
      headers: headers
    });
  }

  updateBackgroundCheck(employeeId: string, backgroundCheckId: string, backgroundCheckSubmit: BackgroundCheckSubmit): Observable<any> {
    return this.http.put<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.BACKGROUND_CHECKS}/${backgroundCheckId}`, backgroundCheckSubmit, {
      headers: headers
    });
  }

  deleteBackgroundCheck(employeeId: string, backgroundCheckId: string): Observable<any> {
    return this.http.delete<any>(`${this.envService.env.apiUrl}${api_routes.TALENT}/${employeeId}/${api_routes.BACKGROUND_CHECKS}/${backgroundCheckId}`, {
      headers: headers
    });
  }
}
